'use strict';

define('FastActionView',[
  'backbone',
  'fastaction_config',
  'fast_databag',
  'auth_popups',
  'hbs!template-main',
  'ActionTagConfig',
  'cookieConsentConfiguration'
], function (Backbone, fastaction_config, fast_databag, auth_popups, template_main, ActionTagConfig, cookieConsentConfig) {
  var $ = Backbone.$,
    _ = Backbone._,
    fastActionHtml = '<i>Fast</i><b>Action</b>';
  return Backbone.View.extend({
    __name__: 'FastActionView',
    events: {
      'click .toggle-menu': 'toggleMenu',
      'click #profile-menu a': 'closeMenu'
    },
    initialize: function (options) {
      _.bindAll(this, 'render');
      this.asked = false;
      this.options = options;
      this.resources = this.options.resources || {};
      this.listenTo(this.model, 'sync', this.render);
      this.listenTo(this.model, 'clear', this.render);
      this.listenTo(fast_databag, 'sync', this.render);
      this.listenTo(fast_databag, 'clear', this.render);
      this.listenTo(cookieConsentConfig, 'change:functionalAccepted', this.render);
      return this.render();
    },
    toggleMenu: function (e) {
      e.preventDefault();
      var that = $(e.currentTarget);
      if (/^https?/.test(that.attr('href'))) {
        return;
      }
      var position = that.position();
      position.top += that.height() - 2;
      this.$('#profile-menu').toggle().css(position);
      that.toggleClass('menu-open');
      return this;
    },
    closeMenu: function (e) {
      e.preventDefault();
      this.$('#profile-menu').hide();
      this.$('.profile-link').removeClass('menu-open');
      return this;
    },
    clearFeedback: function () {
      return this;
    },
    render: function () {
      var context = {
        fastaction_url: fastaction_config.urls.base(),
        resources: this.resources || {},
        config: ActionTagConfig || {},
        cookieCompliance: false
      };

      var fastActionSessionId = this.model.has('fastActionSessionId') ? this.model.get('fastActionSessionId') : null;

      if (fastActionSessionId) {
        context.authed = this.model.get('authed');
        context.name = fast_databag.name() || this.model.name();
        context.id = this.model.get('id');
      }

      if (!this.options.nologin) {
        context.authed = true;
      }

      context.text = {
        EditMyBlankProfile: this.resources.fill(this.resources.PrimaryResources.EditMyBlankProfile, fastActionHtml),
        ForBlank: this.resources.fill(this.resources.PrimaryResources.ForBlank, fastActionHtml)
      };

      if (cookieConsentConfig.areFunctionalCookiesAccepted()) {
        context.cookieCompliance = true;
      }

      this.$el.html(template_main(context));

      auth_popups(fastActionSessionId);

      return this;
    }
  });
});

